module.exports = __webpack_public_path__ + "img/special.d58831c7.svg";